import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/authentication';
import { MessServiceService, User } from '@app/shared/common';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  /**
   * @decription
   * Main application header. Contain breadcrumbs and logout
   */

  /**
   * * General
   * @curentUser Current logged user
   * @subscriptions Subscriptions array
   * @websiteUrl WEBSITE url
   * @cmsLogo Path to logo on server
   * @mediaUrl Path where all upload media are stored on server
   */
  curentUser: User;
  subscriptions: Subscription[] = [];
  websiteUrl: string;
  cmsLogo: string;
  mediaUrl: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private messService: MessServiceService,
    private store: Store<{ config: any }>
  ) {
    /**
     * Get config from ngrx store
     */
    this.subscriptions.push(
      store.select('config').subscribe((res) => {
        this.websiteUrl = res.apiUrl;
        this.mediaUrl = res.mediaUrl;
      })
    );
  }

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.curentUser = this.authService.userValue;
    this.subscriptions.push(
      this.authService.userSubject.subscribe((res) => {
        this.curentUser = res;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
  *                HELPERS
  ======================================= */
  onLogout() {
    this.subscriptions.push(
      this.authService.logout().subscribe(() => {
        this.router.navigate(['/login']);
      })
    );
  }

  onCancelImpersonate() {
    this.subscriptions.push(
      this.authService.cancelImpersonate().subscribe({
        next: (res: any) => {
          this.messService.addSuccess({ detail: res.message });
        },
      })
    );
  }
}
